import { render } from "./adminLayout.vue?vue&type=template&id=fdb01944&scoped=true"
import script from "./adminLayout.vue?vue&type=script&lang=js"
export * from "./adminLayout.vue?vue&type=script&lang=js"

import "./adminLayout.vue?vue&type=style&index=0&id=fdb01944&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdb01944"]])

export default __exports__